import React from "react";

const Spinner: React.FC = () => (
    <div className="spinner-container">
        <div className="spinner-svg-container">
            <svg viewBox="0 0 50 50" className="spinner-svg">
                {[...Array(12)].map((_, i) => {
                    const angle = (i * 30) * (Math.PI / 180);
                    const r = 18;
                    const cx = 25 + r * Math.cos(angle);
                    const cy = 25 + r * Math.sin(angle);
                    return (
                        <circle
                            key={i}
                            cx={cx}
                            cy={cy}
                            r="2"
                            style={{
                                opacity: 1 - (i * 0.08)
                            }}
                        />
                    );
                })}
            </svg>
        </div>
    </div>
);
export default Spinner;
